import { accountActions } from 'core/Account';
import { config } from 'config';
import { createFormData } from 'hooks';
import i18n from 'i18nextInstance';
import { parseSelect } from 'shared/utils';
import professionalServices from 'core/Professional/services';
import { push } from 'react-router-redux';
import userServices from './services';
import {
    call,
    put,
    select,
    takeEvery
} from 'redux-saga/effects';
import {
    createUser,
    deleteUser,
    getUser,
    getUserList,
    setUserList,
    setUserLoading,
    setUserRegistrationError,
    setUserSelected,
    updateUser
} from './';
const { redirectAfterLogin } = config;

function* _createUser ({ payload: { file, form } }) {
    try {
        yield put(setUserRegistrationError({}));
        const { data: { id: user_id } } = yield call(userServices.createUser, null, form);
        if (file) {
            yield call(professionalServices.uploadAvatar, null, createFormData({
                avatar: file,
                ...(user_id && { user_id })
            }));
        }
        yield put(push(i18n.t('/usuarios/listar')));
    } catch (e) {
        const errors = e?.response?.data;
        if (!!errors) {
            yield put(setUserRegistrationError({
                ...(errors.identification && errors.identification[0] === 'IDENTIFICATION_ALREADY_IN_USE'
                    && { identification: i18n.t('Ya utilizado') }),
                ...(errors.email && errors.email[0] === 'EMAIL_REGISTERED_AS_ADMIN'
                    && { email: i18n.t('Ya utilizado') })
            }));
        }
    }
}

function* _deleteUser ({ payload }) {
    try {
        yield call(userServices.deleteUser, { id: payload });
        yield put(push(i18n.t('/usuarios/listar')));
    } catch (e) {}
}

const parseUser = ({
    companies_related,
    coverages_related,
    doctors_related,
    locked_actions,
    workplaces_related,
    ...user
}) => ({
    ...user,
    companies_related: parseSelect(companies_related),
    coverages_related: parseSelect(coverages_related),
    doctors_related: doctors_related.map(({
        first_name,
        last_name,
        ...doctor
    }) => ({
        ...doctor,
        first_name,
        last_name,
        name: `${ last_name }, ${ first_name }`
    })),
    locked_actions: locked_actions.map(({ name }) => name),
    workplaces_related: parseSelect(workplaces_related)
});

function* _getUser ({ payload }) {
    try {
        yield put(setUserSelected({}));
        yield put(setUserLoading(true));
        const { data } = yield call(userServices.getUser, { id: payload });
        yield put(setUserSelected(parseUser(data)));
    } catch (e) {
    } finally {
        yield put(setUserLoading(false));
    }
}

function* _getUserList ({ payload }) {
    try {
        yield put(setUserLoading(true));
        const { data: { data } } = yield call(userServices.getUsersList, null, payload);
        const { account: { user: { id: userId } } } = yield select();
        yield put(setUserList(data.filter(({ id }) => id !== userId)));
    } catch (e) {

    } finally {
        yield put(setUserLoading(false));
    }

}

function* _updateUser ({ payload: { file, form, pathname } }) {
    try {
        const id = form.id;
        delete form.avatar;
        const session = JSON.parse(localStorage.getItem('sessionData'));

        yield call(userServices.updateUser, { id }, form);

        if (!!file) {
            yield call(professionalServices.uploadAvatar, null, createFormData({
                avatar: file,
                ...(id && { user_ud: id })
            }));
        }

        if (pathname === '/perfil' || session.user.id === id) {
            yield put(accountActions.replaceAccountUser(form));
            yield put(push(redirectAfterLogin ?? i18n.t('/dashboard')));
        } else {
            yield put(push(i18n.t('/usuarios/listar')));
        }
        yield put(setUserSelected({}));
    } catch ({ response, response: { data, status } }) {
        const errors = {};
        if (data.identification) {
            const identificationError = data?.identification[0];
            switch (identificationError) {
            case 'FIELD_REQUIRED':
                errors.identification = i18n.t('Requerido');
                break;
            case 'IS_ALREADY_TAKEN':
                errors.identification = i18n.t('Ya fue utilizado');
                break;
            case 'LENGTH_ERROR':
                errors.identification = i18n.t('Máximo 8 caracteres');
                break;
            default:
                errors.identification = i18n.t('Error desconocido');
            }
        }
        if (data.email) {
            const emailError = data?.email[0];
            switch (emailError) {
            case 'EMAIL_REGISTERED_AS_ADMIN':
                errors.email = i18n.t('Ya fue registrado como administrador');
                break;
            case 'FIELD_REQUIRED':
                errors.email = i18n.t('Requerido');
                break;
            case 'IS_ALREADY_TAKEN':
                errors.email = i18n.t('Ya fue utilizado');
                break;
            default:
                errors.email = i18n.t('Error desconocido');
            }
        }
        yield put(setUserRegistrationError(errors));
    } finally {}
}

export default [
    takeEvery(createUser.type, _createUser),
    takeEvery(deleteUser.type, _deleteUser),
    takeEvery(getUser.type, _getUser),
    takeEvery(getUserList.type, _getUserList),
    takeEvery(updateUser.type, _updateUser)
];
